/* unplugin-vue-components disabled */import script from "./ServiceBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceBase.vue?vue&type=script&setup=true&lang=js"

import "./ServiceBase.vue?vue&type=style&index=0&id=133201dc&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133201dc"]])

export default __exports__